
import { supabase } from '../../lib/supabase';
import { cleanPhone } from '../../utils/phoneUtils';
import { Lead } from '../../types';

/**
 * Sincroniza informações do Lead com as conversas do Chat.
 * Atualiza o assigned_to e tags da conversa correspondente ao WhatsApp do Lead.
 * 
 * SEGURANÇA: Requer organizationId para garantir isolamento multi-tenant.
 * 
 * @param lead O lead com as informações atualizadas
 * @param organizationId ID da organização (obrigatório para isolamento)
 */
export const syncLeadWithChat = async (lead: Lead, organizationId: string): Promise<void> => {
    if (!organizationId) {
        console.warn('[ChatService] syncLeadWithChat: organizationId ausente, pulando sincronização.');
        return;
    }

    let phoneDigits = cleanPhone(lead.whatsApp || '');
    if (phoneDigits.length < 10 && lead.contactId) {
        const { data } = await supabase
            .from('contacts')
            .select('phone, whatsapp')
            .eq('id', lead.contactId)
            .eq('organization_id', organizationId)
            .maybeSingle();
        const raw = data?.whatsapp || data?.phone || '';
        phoneDigits = cleanPhone(raw || '');
    }

    if (phoneDigits.length < 10) {
        console.warn('[ChatService] syncLeadWithChat: telefone insuficiente para casar conversa, pulando sincronização.');
        return;
    }

    try {
        const phone = phoneDigits;
        // O JID do WhatsApp geralmente é 5511999999999@s.whatsapp.net
        // Usamos ilike com % para garantir que encontre mesmo com sufixos

        const { error } = await supabase
            .from('chat_conversations')
            .update({
                assigned_to: lead.agent || null,
                tags: lead.tags || []
            })
            .eq('organization_id', organizationId) // SEGURANÇA: Filtra por organização
            .ilike('remote_jid', `${phone}%`);

        if (error) {
            console.error('[ChatService] Erro ao sincronizar conversa:', error);
            throw new Error(`Falha ao sincronizar chat: ${error.message}`);
        }
    } catch (error) {
        console.error('[ChatService] Erro inesperado:', error);
        // Não relançamos o erro para não bloquear o fluxo do Lead, apenas logamos
    }
};
